import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Schedule as SSchedule,Edit,Delete,HourglassEmpty,Done,EditAttributes,CropFree,ConfirmationNumber,Close,Filter9Plus} from '@material-ui/icons';


import {
  Slide,
  Button,
  IconButton,
  Typography,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Backdrop,
  CircularProgress,
  LinearProgress,
  Chip,
  FormHelperText,
  Grid,
  Toolbar
} from "@material-ui/core";



import { withLocalize,Translate } from "react-localize-redux";
import MUIDataTable from "mui-datatables";

import API from './api';
import { useSnackbar } from 'notistack';

// import * as userInfo from "./login_info.js";

import UserInfo from "./login_info";

import axios from 'axios';

import {TransportService} from "./../../utils/web_config_2";

import { MuiPickersUtilsProvider, DatePicker,TimePicker,KeyboardTimePicker, DateTimePicker} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import { format, parseISO ,parse} from 'date-fns'

import Format from "date-fns/format";










const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",
    margin:theme.spacing(1)

  },
  formTitle:{
    flexGrow:1,
}
,
chip: {
  margin: theme.spacing(0.5),
},appBar: {
  position: 'relative',
},
title: {
  marginLeft: theme.spacing(2),
  flex: 1,
},
}));

function Schedule(props) {
  const classes = useStyles1();
  /// static organizationid
  

  var React = require('react');
  var QRCode = require('qrcode.react');

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [operatorData, setOperatorData] = useState({});

  const [scheduleMessage,setScheduleMessage]=useState("Loading...");



  const [selectedDate, handleDateChange] = useState(new Date());


  const columns = [

    {
      name: "id",
      label: "id",
      options: {
       display:false,
       filter: true,
       sort: true,
      }
     },
    {
      name: "date_time",
      label: "Date/Time",
      options: {
       filter: true,
       sort: true,
      }
     },
    {
     name: "driver_name",
     label: <Translate id="operator_schedule.table.driver_name" />,
     options: {
      filter: true,
      sort: true,
     }
    },
    {
     name: "code",
     label: <Translate id="operator_schedule.table.code" />,
     options: {
      filter: true,
      sort: false,
     }
    },
    {
     name: "route",
     label: <Translate id="operator_schedule.table.route" />,
     options: {
      filter: true,
      sort: false,
     }
    },
    {
     name: "plate_number",
     label: <Translate id="operator_schedule.table.plate_number" />,
     options: {
      filter: true,
      sort: false,
     }
    },{
      name: "total_seats",
      label: <Translate id="operator_schedule.table.total_seats" />,
      options: {
       filter: true,
       sort: false,
      }
     },{
      name: "total_sold_seat",
      label: <Translate id="operator_schedule.table.total_sold_seat" />,
      options: {
       filter: true,
       sort: false,
      }
     },{
      name: "total_sales",
      label: "Total sales",
      options: {
       filter: true,
       sort: false,
      }
     },{
      name: "scheduling_mode",
      label: <Translate id="operator_schedule.table.scheduling_mode" />,
      options: {
       filter: true,
       sort: false,
      }
     },{
      name: "booked_seats",
      label: <Translate id="operator_schedule.table.booked_seats" />,
      options: {
       filter: true,
       sort: false,
      }
     },
     {
      name: "status",
      label: "Status",
      options: {
       filter: true,
       sort: false,
       customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <Chip
          color={value=='SCHEDULED'?"primary":"secondary"}
          label={value}
          onDelete={()=>{}}
          deleteIcon={value=='SCHEDULED'?<Done/>:<HourglassEmpty />}
        ></Chip>
            
        );
      }
      },
      
     }
   ];

  


  
   
   const options = {
    textLabels: {
      body: {
        noMatch: scheduleMessage
      },
    },
     filterType: 'checkbox',
     download:true,
     responsive:"standard",
     selectableRows:"single",
     rowsPerPage: 10,
     elevation:0,
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
      <Box display="flex">
       
        <Chip
        color="secondary"
        variant="outlined"
        deleteIcon={<Edit/>}
        label={"Edit Schedule"}
        onClick={()=>{
      var id=displayData[selectedRows.data[0]['index']]['data'][0];
      var obj=schedules.find((item,i) => {
      return item.id == id;
   });

   setScheduleid(id);
    setVehicle({value:obj.vehicle_id,error:""});
    setRoute({value:obj.route_id,error:""});
    setDriver({value:obj.driver_id,error:""});
    setDate({value:obj.date_time,error:""});
    setTime({value:obj.date_time,error:""});
    setMode({value:obj.scheduling_mode,error:""});
    setDescription({value:"description",error:""});
    setDevice({value:"1",error:""});

    console.log("schdeule timw date=====",Format(Date.parse(obj.date_time), ["yyyy-MM-dd"]));

    var ExistingDate=obj.date_time.split(" ");


    console.log("date",ExistingDate[0]);

    console.log("time",ExistingDate[1]);

     var datetime = new Date(ExistingDate[0]);

    setScheduleDate({value:Format(datetime, ["yyyy-MM-dd"]),error:""});

    setScheduleTime({value:ExistingDate[1],error:""});
    

    setDialogedit(true);

        }}
        onDelete={()=>{

        }}
        className={classes.chip}
            />
             <Chip
        color="primary"
        variant="outlined"
        deleteIcon={<EditAttributes/>}
        label={"Change Status"}
        onClick={()=>{


          var index;
          selectedRows.data.map((d)=>{
            index=d['index'];console.log("id:"+d['index']);
          });
          var obj=schedules.find((item,i) => {
            return i == index;
         })
          var stat=obj.status;
          var id=obj.id;
          setDescription({value:obj.description,error:""});
          setStatus({value:stat,error:""});
          console.log("status:"+status.value);
          setScheduleid(id);
          console.log("ID:"+id);
      
          setStatusdialog(true);
        }}
        onDelete={()=>{

        }}
        className={classes.chip}
            />



           <Chip
        color="primary"
        variant="outlined"
        deleteIcon={<CropFree/>}
        label={"Generate QR Code"}
        onClick={()=>{


          var index;
          selectedRows.data.map((d)=>{
            index=d['index'];console.log("id:"+d['index']);
          });
          var obj=schedules.find((item,i) => {
            return i == index;
         })
          var stat=obj.status;
          var id=obj.id;
          generate_qr_code(id);
        }}
        onDelete={()=>{

        }}
        className={classes.chip}
            />  

             <Chip
        color="primary"
        variant="outlined"
        deleteIcon={<ConfirmationNumber/>}
        label={"View sold tickets"}
        onClick={()=>{
          var id=displayData[selectedRows.data[0]['index']]['data'][0];
          console.log("schedule id",id);
          // var obj=schedules.find((s)=>s.id==id);
          get_tickets(id);
        }}
        onDelete={()=>{

        }}
        className={classes.chip}
            /> 
        
      
      </Box>
    ),
   };

// tickets column 




const columns1 = [

  {
    name: "id",
    label: "id",
    options: {
     display:false,
     filter: true,
     sort: true,
    }
   },
  {
    name: "ticket_number",
    label: "Ticket Number",
    options: {
     filter: true,
     sort: true,
    }
   },
   {
    name: "cashier_name",
    label: "Cashier names",
    options: {
     filter: true,
     sort: true,
    }
   },
  {
   name: "owner_type",
   label: "Owner",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "customer_names",
   label: "Customer names",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "route",
   label: "Route",
   options: {
    filter: true,
    sort: false,
   }
  },
  {
   name: "actual_ticket_amount",
   label: "Total amount",
   options: {
    filter: true,
    sort: false,
   }
  },{
    name: "currency",
    label: "Currency",
    options: {
     filter: true,
     sort: false,
    }
   },{
    name: "seat_number",
    label:"Seat Number",
    options: {
     filter: true,
     sort: false,
    }
   },{
    name: "ticket_type",
    label: "Ticket Type",
    options: {
     filter: true,
     sort: false,
    }
   },{
    name: "payment_mode",
    label: "Payment mode",
    options: {
     filter: true,
     sort: false,
    }
   },{
    name: "generated_at",
    label: "Date",
    options: {
     filter: true,
     sort: false,
    }
   },
   {
    name: "status",
    label: "Status",
    options: {
     filter: true,
     sort: false,
     customBodyRender: (value, tableMeta, updateValue) => {
       if(value=="Second Tap"){
         return ( <Chip
         color="primary"
         label={value}
         icon={<Done/>}
       />);
       }else{
        return (
          <Chip
          color={value=='USED'?"primary":"secondary"}
          label={value}
          icon={value=='USED'?<Done/>:<HourglassEmpty />}
       />     
        );
       }
    
    }
    },
    
   }
 ];



// options tickets 


const options1 = {
  textLabels: {
    body: {
      noMatch: scheduleMessage
    },
  },
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
  <Box>    </Box>
  ),
 };




  // new schedule dialog 

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
///  menu action

const [anchorEl, setAnchorEl] = useState(null);
const openMenu = Boolean(anchorEl);

const handleClickMenu = (event) => {
  setAnchorEl(event.currentTarget);
};

const handleCloseMenu = () => {
  setAnchorEl(null);
};


useEffect(()=>{

  console.log("== props ===",props);

  var data = {};
    const data1 = localStorage.getItem("nx_op");
    if (data1 != null) {
      data = JSON.parse(data1);
    }
    setOperatorData(data);
   

    

  getSchedules(data.token);
  getRoutes(data.token);
  getVehicles(data.token);
  getDrivers(data.token);
  
},[]);


//// select schedules

const [schedules,setSchedules]=useState([]);
const [loadSchedule,setLoadschedule]=useState(false);
const getSchedules=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const scheduleInstance = axios.create(new TransportService().setHeaders(token));
  setLoadschedule(true);
  scheduleInstance.get('/api/v1/scheduling/getSchedulesByOrganization/'+new UserInfo().ID,
  )
  .then(res => {
    console.log("=== schedules  ===",res.data);
    setLoadschedule(false);
    if(res.status==200){
      if(res.data.length!=0){
        let s=res.data;
        const data=[];
        s.map((d)=>{
          var obj={id:d['id'],driver_id:d['driver']['id'],route_id:d['route']['id'],vehicle_id:d['vehicle']['id'],description:d['description'],date_time:d['scheduled_on_date_time'],driver_name: d['driver']!=null?d['driver']['first_name']+" "+d['driver']['last_name']:"No driver", code: d['code'], route: d['route']['name'], plate_number: d['vehicle']['number_plate'],total_seats:d['total_seats'],total_sold_seat:d['total_sold_seats'],scheduling_mode:d['scheduling_mode'],booked_seats:d['booked_seats'],booking_limit:d['booking_limit'],status:d['status']};
          data.push(obj);
        });
        setSchedules(data);
      }else{
        setScheduleMessage("No schedules available!");
      }
    }
    
    
  }).catch(err=>{
    setScheduleMessage("Something went wrong!");
    setLoadschedule(false);
    enqueueSnackbar(err.message, { 
      variant: 'error',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  });
  });
}



///// load drivers



const [drivers,setDrivers]=useState([]);
const getDrivers=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const driverInstance = axios.create(new TransportService().setHeaders(token));
  driverInstance.get("/api/v1/integrations/getDriversByOrganization/"+new UserInfo().ORG_ID
 ).then(res=>{
  //  console.log("== drivers ==",res.data);
      setDrivers(res.data);   
 })
 .catch(err=>{
   console.log(err.message);
   if(err.response){
     console.log(err.response.data.message);
   }
 });
}


//// load route


const [routes,setRoutes]=useState([]);
const getRoutes=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const routeInstance = axios.create(new TransportService().setHeaders(token));
  routeInstance.get('/api/v1/integrations/getRoutesByOrganization/'+new UserInfo().ORG_ID,{
    
  })
  .then(res=>{
    console.log(res.data);
    if(res.status===200){
      setRoutes(res.data);
    }
    
  });
}


//// load vehicle 


const [vehicles,setVehicles]=useState([]);
const getVehicles=(token)=>{
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const vehicleInstance = axios.create(new TransportService().setHeaders(token));
  vehicleInstance.get('/api/v1/integrations/getActiveVehiclesByOrganization/'+new UserInfo().ORG_ID,{
  // vehicleInstance.get('/api/v1/integrations/getVehiclesByOrganization/'+new UserInfo().ORG_ID,{
  
  }).then(res=>{
setVehicles(res.data);
  });
}


//// add new schedule


const [scheduleStatus,setSchedulestatus]=useState({load:false,status:false});
const [vehicle,setVehicle]=useState({value:"",error:""});
const [route,setRoute]=useState({value:"",error:""});
const [driver,setDriver]=useState({value:"",error:""});
const [date,setDate]=useState({value:"",error:""});
const [time,setTime]=useState({value:"",error:""});
const [mode,setMode]=useState({value:"",error:""});
const [description,setDescription]=useState({value:"",error:""});
const [device,setDevice]=useState({value:"",error:""});
const [scheduleDate,setScheduleDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
const [scheduleTime,setScheduleTime]=useState({value:new Date(),error:""}); 

const onSaveSchedule=()=>{
  console.log("save schedule");
  if(vehicle.value===""){
    setVehicle({value:"",error:"Select vehicle"});
  }else if(route.value===""){
    setRoute({value:"",error:"Select route"});
  }else if(driver.value===""){
    setDriver({value:"",error:"Select driver"});
  }else if(mode.value===""){
    setMode({value:"",error:"Select mode"});
  }else{
    setSchedulestatus({load:true,status:false});
    let dt=scheduleDate.value+" "+scheduleTime.value;
    console.log("schedule date time",dt);
    console.log("date time:"+date.value);
    console.log("date time:"+dt);
    console.log("driver:"+driver.value);
    console.log("mode:"+mode.value);
    console.log("vehicle:"+vehicle.value);
    console.log("route:"+route.value);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const scheduleInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    scheduleInstance.post("/api/v1/scheduling/addSchedule",
      {
        "description": description.value,
        "device_id":"1",
        "driver_id": driver.value,
        "route_id": route.value,
        "scheduled_on_date_time": dt,
        "scheduling_mode": mode.value,
        "vehicle_id": vehicle.value
      }
      ).then(res=>{
        setSchedulestatus({load:false,status:false});
        if(res.status==200){
          setSchedulestatus({load:false,status:true});
          setOpen(false);
          enqueueSnackbar('Schedule successifuly created!', { 
            variant: 'success',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        console.log("=====  schedule created ======",res.data.data);

        var objs=schedules;
        var r_obj=res.data.data;
        var obj={id:r_obj['id'],driver_id:r_obj['driver']['id'],route_id:r_obj['route']['id'],vehicle_id:r_obj['vehicle']['id'],description:r_obj['description'],date_time:r_obj['scheduled_on_date_time'],driver_name: r_obj['driver']!=null?r_obj['driver']['first_name']+" "+r_obj['driver']['last_name']:"No driver", code: r_obj['code'], route: r_obj['route']['name'], plate_number: r_obj['vehicle']['number_plate'],total_seats:r_obj['total_seats'],total_sold_seat:r_obj['total_sold_seats'],scheduling_mode:r_obj['scheduling_mode'],booked_seats:r_obj['booked_seats'],booking_limit:r_obj['booking_limit'],status:r_obj['status']};
        objs.unshift(obj);
        setSchedules([]);
        setSchedules(objs);  
        // getSchedules(operatorData.token);
        }else if(res.status===400){
          setSchedulestatus({load:false,status:false});
          enqueueSnackbar('Internal server error', { 
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        }
      })
      .catch(err=>{
        if(err.response.status==400){
          enqueueSnackbar(err.response.data.message, { 
            variant: 'error',
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'right',
          },
        });
        }
      });
  }
}

// dialog edit  dialog

const [editDialog,setDialogedit]=useState(false);

// edit schedule 

const [editLoad,setEditLoad]=useState(false);
const edit_schedule=()=>{
  if(vehicle.value===""){
    setVehicle({value:"",error:"Select vehicle"});
  }else if(route.value===""){
    setRoute({value:"",error:"Select route"});
  }else if(driver.value===""){
    setDriver({value:"",error:"Select driver"});
  }else if(mode.value===""){
    setMode({value:"",error:"Select mode"});
  }else{
    let dt=scheduleDate.value+" "+scheduleTime.value;

    console.log("description"+ description.value,
    "device_id"+"1",
    "driver_id"+ driver.value,
    "id"+ scheduleId,
    "route_id"+route.value,
    "scheduled_on_date_time"+ dt,
    "scheduling_mode"+ mode.value,
    "vehicle_id"+ vehicle.value);
    setEditLoad(true);
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const scheduleInstance = axios.create(new TransportService().setHeaders(operatorData.token));
    scheduleInstance.put('/api/v1/scheduling/modifySchedule',
    {
        "description": description.value,
        "device_id": "1",
        "driver_id": driver.value,
        "id": scheduleId,
        "route_id": route.value,
        "scheduled_on_date_time": dt,
        "scheduling_mode": mode.value,
        "vehicle_id": vehicle.value
      }).
    then(res=>{

      console.log("===== after schedule edited =====",res.data.data);

      var r_obj=res.data.data;
      var obj={id:r_obj['id'],driver_id:r_obj['driver']['id'],route_id:r_obj['route']['id'],vehicle_id:r_obj['vehicle']['id'],description:r_obj['description'],date_time:r_obj['scheduled_on_date_time'],driver_name: r_obj['driver']!=null?r_obj['driver']['first_name']+" "+r_obj['driver']['last_name']:"No driver", code: r_obj['code'], route: r_obj['route']['name'], plate_number: r_obj['vehicle']['number_plate'],total_seats:r_obj['total_seats'],total_sold_seat:r_obj['total_sold_seats'],scheduling_mode:r_obj['scheduling_mode'],booked_seats:r_obj['booked_seats'],booking_limit:r_obj['booking_limit'],status:r_obj['status']};
      var index=schedules.findIndex((s)=>s.id==scheduleId);
      var objs=schedules;
      objs[index]=obj;
      setSchedules(objs);


      setEditLoad(false);
      enqueueSnackbar('Schedule successifuly updated!', { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    setDialogedit(false);
    })
    .catch(err=>{

      setEditLoad(false);

      if(err.response.status==400){
        enqueueSnackbar(err.response.data.message, { 
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      }

      enqueueSnackbar(err.message, { 
        variant: 'error',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });

    });

  }
}


// change status dialog

const [statusDialog,setStatusdialog]=useState(false);

// change schedule status
const [scheduleId,setScheduleid]=useState(0);
const [statusLoad,setStatusload]=useState({load:false,status:false});
const [status,setStatus]=useState({value:"",error:""});
const changeSchedule=()=>{
  if(description.value==""){
    setDescription({value:"",error:"Enter description"});
  }else if(status.value==""){
    setStatus({value:"",error:"Choose status"});
  }else{
    axios.defaults.baseURL = new TransportService().BASE_URL;
    const scheduleInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  
    setStatusload({load:true,status:false});
    scheduleInstance .put("/api/v1/scheduling/changeScheduleStatus",
    {
      "description":description.value,
      "schedule_id": scheduleId,
      "status":status.value
    }
    ).then(res=>{
      setStatusload({load:false,status:false});
      if(res.status===200){
        setStatusdialog(false);
        setStatusload({load:false,status:true});
        enqueueSnackbar('Schedule status changed successifuly!', { 
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        },
      });
      getSchedules(operatorData.token);
      }
      
    }).catch(err=>{
      enqueueSnackbar(err.message, { 
        variant: 'success',
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right',
      },
    });
    });


  } 
}


// generate qr code  dialog

const [qrDialog,setQrDialog]=useState(false);

// generate qr code 
const [qrIdentifier,setQrIdentifier]=useState(null);
const [qrLoad,setQrLoad]=useState(false);
const [qrStatus,setQrStatus]=useState(false);

const generate_qr_code=(id)=>{
  setQrLoad(true);
  setQrDialog(true);
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const qrInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  qrInstance.get('/api/v1/scheduling/generateQRCode/'+id
  ).then(res=>{
    
    var identifier=res.data.data.qr_code_itenfier;
    console.log("identifier :"+id);
    var code="B"+identifier;
    setQrIdentifier(code);
    setQrStatus(true);
    setQrLoad(false);

  }).catch(err=>{
console.log(err);
  });
  
}


// get schedule tickets dialog

const [ticketsDialog,setTicketsDialog]=useState(false);

//get schedule tickets 
const [ticketsLoad,setTicketsLoad]=useState(false);
const [tickets,setTickets]=useState([]);
const get_tickets=(id)=>{

  console.log("== view tickets clicked ==");

  setTickets([]);
  setTicketsLoad(true);
  setTicketsDialog(true);
  axios.defaults.baseURL = new TransportService().BASE_URL;
  const ticketsInstance = axios.create(new TransportService().setHeaders(operatorData.token));
  ticketsInstance.get('/api/v1/ticketing/getTicketsByScheule/'+id)
  .then(res=>{
    console.log("===== schedule tickets ========",res.data);
    setTicketsLoad(false);
    if(res.data.length==0){
      console.log("No tickets available");
    }else{
      var objs=res.data;
      objs.map((o)=>{

        if(o['status']!="CANCELED"){
          if(o['channel_type']=="CARD" && o['ticket_type']=="ELECTRONIC"){
            o['route']=o['intermediate_route']['stops_combination'];
            if(o['scheduling_mode']=="MULTIPLE"){
              if(o['status']=="USED"){
                o['status']="Second Tap";
              }else{
                o['status']="First Tap";
              }
            }else if(o['scheduling_mode']=="SINGLE"){
              o['status']="Complete";
            }
            
          }else if(o['channel_type']=="POS" && o['ticket_type']=="PAPER_BASED" ){
            o['route']=o.intermediate_route.stops_combination;
          }
        } 
    });
    setTickets(objs);
    }
  }).catch(err=>{
    enqueueSnackbar(err.message, { 
      variant: 'success',
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
    },
  });
  });
}

// trajet dialog
const [trajetDialog,setTrajetDialog]=useState(false);

// new trajet
const [trajetLoad,setTrajetLoad]=useState(false);
const [fromHours,setFromHours]=useState({value:0,error:""});
// const []


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
    <div className={classes.root}>

<Box display="flex">
 
<Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 <Box mr={1}><SSchedule fontSize="large" color="primary"/></Box> 
 <Typography  variant="h5" color="default"><b>Schedules</b></Typography>
</Box>
 
<Button  
className={classes.btn}
size="small"
startIcon={<Add/>} 
onClick={()=>{handleClickOpen()}} 
variant="contained" 
color="primary"
disableElevation={true}>
<Typography noWrap>New schedule</Typography>
</Button>

<Button  
className={classes.btn}
size="small"
startIcon={<Filter9Plus/>} 
onClick={()=>{handleClickOpen()}} 
variant="contained" 
color="primary"
disableElevation={true}>
<Typography noWrap>New Trajet schedule</Typography>
</Button>
</Box>

{/* schedule table  */}


<Box mt={2}>
{loadSchedule&&<LinearProgress />}
<MUIDataTable
  title={"Schedules list"}
  data={schedules}
  columns={columns}
  options={options}
/>
</Box>
 

{/* dialog new schedule  */}

<Dialog
    maxWidth="sm"
    fullWidth
        open={open}
        onClose={handleClose}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >
        <DialogTitle id="new schedule">{"New Schedule"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
             
          <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="selectpos">Choose Vehicle</InputLabel>
        <Select
        size="small"
        label="Select vehicle"
        inputProps={{
          name: 'vehicle',
          id: 'select vehicle',
        }}
        error={vehicle.error!==""}
        onChange={(e)=>{
          
          if(e.target.value===''){
            setVehicle({value:"",error:"Select vehicle"});
          }else{
            setVehicle({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {vehicles.map((v)=>{
            return <MenuItem value={v['id']}>{v['number_plate']}</MenuItem>
          })}
        </Select>
        <FormHelperText error={vehicle.error!==""}>{vehicle.error}</FormHelperText>
      </FormControl>
</Box>

<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
  
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>

<InputLabel htmlFor="route">Choose Route</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select route"
        inputProps={{
          name: 'route',
          id: 'route',
        }}
        error={route.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setRoute({value:"",error:"Select route"});
          }else{
            setRoute({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {routes.map((r)=>{
            if(r.status!=="INITIAL"){
              return <MenuItem value={r['id']}>{r['name']}</MenuItem>
            }
            return null;
          })}
          
        </Select>
        <FormHelperText error={route.error!==""}>{route.error}</FormHelperText>
      </FormControl>
</Box>


<Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
      
                 <InputLabel htmlFor="driver">Choose Driver</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select driver"
        inputProps={{
          name: 'driver',
          id: 'driver',
        }}
        error={driver.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setDriver({value:"",error:"Select driver"});
          }else{
            setDriver({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {drivers.map((d)=>{
            return <MenuItem value={d['id']}>{d['first_name']+" "+d['last_name']}</MenuItem>
          })}

        </Select>
        <FormHelperText error={driver.error!==""}>{driver.error}</FormHelperText>
      </FormControl>
</Box>
            <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
              <Grid container >
                <Grid md={6} xs={12} lg={6}>
                 
                    

<Box mr={1}>
<DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            disablePast
                            autoOk
                            label="Date"
                            value={scheduleDate.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                console.log("choosen2: ",v);
                                setScheduleDate({value:Format(v, ["yyyy-MM-dd"]),error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 1 },
                            }}
                          />
</Box>

               
                </Grid>


                <Grid md={6} xs={12} lg={6}>
                   <Box ml={1} mt={1}>
                   <TextField
                   fullWidth
                   size="small"
    id="time"
    label="Time"
    type="time"
    variant="outlined"
    defaultValue={scheduleTime.value}

    onChange={(e)=>{
      console.log("time",e.target.value);
      setScheduleTime({value:e.target.value+":00",error:""});
    }}
   
    inputProps={{
      step: 300, // 5 min
    }}
  />
                  </Box>
   
                  
                  
                   </Grid>
                
                
                {/* <Grid md={6} xs={12} lg={6}>
                <Box ml={1}>
                <TimePicker
                            ampm={false}
                            fullWidth
                            openTo="hours"
                            views={["hours", "minutes", "seconds"]}
                            format="HH:mm:ss"
                            variant="inline"
                            margin="dense"
                            disablePast
                            autoOk
                            label="Time"
                            value={scheduleTime.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                setScheduleTime({value:v,error:""});
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 1 },
                            }}
                          />
               </Box>

               
               
                </Grid> */}
              </Grid>
            
              </Box>
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
      
                 <InputLabel htmlFor="mode">Choose scheduling mode</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select mode"
        inputProps={{
          name: 'mode',
          id: 'mode',
        }}
        error={mode.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setMode({value:"",error:"Select mode"});
          }else{
            setMode({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
         <MenuItem value={"SINGLE"}>Single</MenuItem>
         <MenuItem value={"MULTIPLE"}>Multiple</MenuItem>
        </Select>
        <FormHelperText error={mode.error!==""}>{mode.error}</FormHelperText>
      </FormControl>
      </Box>

      <Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

    <TextField  size="small" rowsMax={10} rows={10} variant='outlined' label={"Description"} 
    error={description.error!=""}
    helperText={description.error}
    onChange={(e)=>{
      if(e.target.value==""){
        setDescription({value:"",error:"Enter description"});
      }else{
        setDescription({value:e.target.value,error:""})
      }
    }}
    color='primary'  fullWidth multiline />
     </FormControl>
    </Box>  
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" color="secondary" autoFocus>
            Cancel
          </Button>
          <Button disableElevation onClick={onSaveSchedule} variant="contained" color="primary">
           {scheduleStatus.load?<CircularProgress size={25} color="secondary"/>:"Save"}
          </Button>
        </DialogActions>
      </Dialog>


{/* dialog edit schedule  */}

<Dialog
    maxWidth="sm"
    fullWidth
        open={editDialog}
        onClose={()=>{
          setDialogedit(false);   
        }}
        aria-labelledby="edit_schedule"
        aria-describedby="edi_schedule"
      >

    
        <DialogTitle id="edit_schedule">{"Edit Schedule"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
            
          <Box>
             
             <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                    <InputLabel htmlFor="selectpos">Choose Vehicle</InputLabel>
           <Select
           size="small"
           label="Select vehicle"
           inputProps={{
             name: 'vehicle',
             id: 'select vehicle',
           }}
           defaultValue={vehicle.value}
           error={vehicle.error!==""}
           onChange={(e)=>{
             
             if(e.target.value===''){
               setVehicle({value:"",error:"Select vehicle"});
             }else{
               setVehicle({value:e.target.value,error:""});
             }
           }}
           >
             <MenuItem value="">
               <em>None</em>
             </MenuItem>
             {vehicles.map((v)=>{
               return <MenuItem value={v['id']}>{v['number_plate']}</MenuItem>
             })}
           </Select>
           <FormHelperText error={vehicle.error!==""}>{vehicle.error}</FormHelperText>
         </FormControl>
   </Box>
   
   <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
     
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
   
   <InputLabel htmlFor="route">Choose Route</InputLabel>
           <Select
           size="small"
           helperText={"error"} 
           label="Select route"
           defaultValue={route.value}
           inputProps={{
             name: 'route',
             id: 'route',
           }}
           error={route.error!==""}
           onChange={(e)=>{
             if(e.target.value===''){
               setRoute({value:"",error:"Select route"});
             }else{
               setRoute({value:e.target.value,error:""});
             }
           }}
           >
             <MenuItem value="">
               <em>None</em>
             </MenuItem>
             {routes.map((r)=>{
               if(r.status=="PLANED"){
                 return <MenuItem value={r['id']}>{r['name']}</MenuItem>
               }
               return null;
             })}
             
           </Select>
           <FormHelperText error={route.error!==""}>{route.error}</FormHelperText>
         </FormControl>
   </Box>
   
   
   <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
         
                    <InputLabel htmlFor="driver">Choose Driver</InputLabel>
           <Select
           size="small"
           helperText={"error"} 
           label="Select driver"
           defaultValue={driver.value}
           inputProps={{
             name: 'driver',
             id: 'driver',
           }}
           error={driver.error!==""}
           onChange={(e)=>{
             if(e.target.value===''){
               setDriver({value:"",error:"Select driver"});
             }else{
               setDriver({value:e.target.value,error:""});
             }
           }}
           >
             <MenuItem value="">
               <em>None</em>
             </MenuItem>
             {drivers.map((d)=>{
               return <MenuItem value={d['id']}>{d['first_name']+" "+d['last_name']}</MenuItem>
             })}
   
           </Select>
           <FormHelperText error={driver.error!==""}>{driver.error}</FormHelperText>
         </FormControl>
   </Box>
               <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
                 <Grid container >
                   <Grid md={6} xs={12} lg={6}>
                    
                       
   
   <Box mr={1}>
   <DatePicker
                               fullWidth
                               disableToolbar
                               variant="inline"
                               format="yyyy-MM-dd"
                               margin="dense"
                               autoOk
                               label="Date"
                               value={scheduleDate.value}
                               inputVariant="outlined"
                               onChange={(v)=>{
                                   console.log("choosen2: ",v);
                                   setScheduleDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                               }}
                               InputProps={{
                                 disableUnderline: true,
                                 style: { paddingRight: 1 },
                               }}
                             />
   </Box>
   
                  
                   </Grid>
                   <Grid md={6} xs={12} lg={6}>
                   <Box ml={1} mt={1}>
                   <TextField
                   fullWidth
                   size="small"
    id="time"
    label="Time"
    type="time"
    variant="outlined"
    defaultValue={scheduleTime.value}

    onChange={(e)=>{
      console.log("time",e.target.value);
      setScheduleTime({value:e.target.value+":00",error:""});
    }}
   
    inputProps={{
      step: 300, // 5 min
    }}
  />
                   {/* <TimePicker
                               ampm={false}
                               fullWidth
                               openTo="hours"
                               views={["hours", "minutes", "seconds"]}
                               format="HH:mm:ss"
                               variant="inline"
                               margin="dense"
                               disablePast
                               autoOk
                               label="Time"
                               value={scheduleTime.value}
                               inputVariant="outlined"
                               onChange={(v)=>{
                                   setScheduleTime({value:v,error:""});
                               }}
                               InputProps={{
                                 disableUnderline: true,
                                 style: { paddingRight: 1 },
                               }}
                             /> */}
                  </Box>
   
                  
                  
                   </Grid>
                 </Grid>
               
                 </Box>
                 <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
   <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
         
                    <InputLabel htmlFor="mode">Choose scheduling mode</InputLabel>
           <Select
           size="small"
           helperText={"error"} 
           label="Select mode"
           defaultValue={mode.value}
           inputProps={{
             name: 'mode',
             id: 'mode',
           }}
           error={mode.error!==""}
           onChange={(e)=>{
             if(e.target.value===''){
               setMode({value:"",error:"Select mode"});
             }else{
               setMode({value:e.target.value,error:""});
             }
           }}
           >
             <MenuItem value="">
               <em>None</em>
             </MenuItem>
            <MenuItem value={"SINGLE"}>Single</MenuItem>
            <MenuItem value={"MULTIPLE"}>Multiple</MenuItem>
           </Select>
           <FormHelperText error={mode.error!==""}>{mode.error}</FormHelperText>
         </FormControl>
         </Box>
   
         <Box mt={1}>
       <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  
   
       <TextField  
       value={description.value}
       size="small" rowsMax={10} rows={10} variant='outlined' label={"Description"} 
       error={description.error!=""}
       helperText={description.error}
       onChange={(e)=>{
         if(e.target.value==""){
           setDescription({value:"",error:"Enter description"});
         }else{
           setDescription({value:e.target.value,error:""})
         }
       }}
       color='primary'  fullWidth multiline />
        </FormControl>
       </Box>  
               
           </Box>
             </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
            setDialogedit(false);
          }} variant="outlined" color="secondary">
            Cancel
          </Button>
          <Button autoFocus disableElevation onClick={()=>{
          edit_schedule();
          }} variant="contained" color="primary">
           {editLoad?<CircularProgress size={25} color="secondary"/>:"Save"}
          </Button>
        </DialogActions>
      </Dialog>



{/* change schedule status  */}

<Dialog
    maxWidth="sm"
    fullWidth
        open={statusDialog}
        onClose={()=>{
          setStatusdialog(false); 
        }}
        aria-labelledby="new branch"
        aria-describedby="new bramnch"
      >

    
        <DialogTitle id="change_status_schedule">{"Change schedule status"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
        
              <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
<FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>
                 <InputLabel htmlFor="status">Choose status</InputLabel>
        <Select
        size="small"
        helperText={"error"} 
        label="Select status"
        inputProps={{
          name: 'status',
          id: 'status',
        }}
        error={status.error!==""}
        onChange={(e)=>{
          if(e.target.value===''){
            setStatus({value:"",error:"Selec status"});
          }else{
            setStatus({value:e.target.value,error:""});
          }
        }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
      <MenuItem value={"INITIAL"} selected={status.value=="INITIAL"?true:false}>Initial</MenuItem>
         <MenuItem value={"SCHEDULED"} selected={status.value=="SCHEDULED"?true:false}>Schedule</MenuItem>
         <MenuItem value={"CANCELED"} selected={status.value=="CANCELED"?true:false}>Canceled</MenuItem>
         <MenuItem value={"CLOSED"} selected={status.value=="CLOSED"?true:false}>Closed</MenuItem>
        </Select>
        <FormHelperText error={mode.error!==""} >{mode.error}</FormHelperText>
      </FormControl>
      </Box>

      <Box mt={1}>
    <FormControl size="small" variant="outlined" fullWidth className={classes.formControl}>  

    <TextField  size="small" rowsMax={10} rows={10} variant='outlined' label={"Description"} 
    error={description.error!=""}
    helperText={description.error}
    onChange={(e)=>{
      if(e.target.value==""){
        setDescription({value:"",error:"Enter description"});
      }else{
        setDescription({value:e.target.value,error:""})
      }
    }}
    value={description.value}
    color='primary'  fullWidth multiline />
     </FormControl>
    </Box>  
            
        </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
           setStatusdialog(false);
          }} variant="outlined" color="secondary" autoFocus>
            Cancel
          </Button>
          <Button disableElevation onClick={()=>{
            changeSchedule();
          }} variant="contained" color="primary">
           {statusLoad.load?<CircularProgress size={25} color="secondary"/>:"Save"}
          </Button>
        </DialogActions>
      </Dialog>


{/* generate schedule Qr code   */}


<Dialog
    maxWidth="sm"
    fullWidth
        open={qrDialog}
        onClose={()=>{
          setQrDialog(false);
        }}
        aria-labelledby="generate_qr"
        aria-describedby="generate_qr"
      >

    
        <DialogTitle id="generate_qr">{"Generate Qr Code"}</DialogTitle>
        <DialogContent>
          <DialogContentText >

{qrLoad?<Box>
  <Grid container>
    <Grid md={2} xs={2} lg={2} sm={2}>
    <CircularProgress disableShrink color="primary" />
    </Grid>
    <Grid md={10} xs={10} lg={10} sm={10}>
      <Typography>Generating QR Code</Typography>
    </Grid>
  </Grid>
</Box>:
  <Box>
        
        <Box mt={1} display='flex' alignItems='center' justifyContent='center'>
        <QRCode value={qrIdentifier}/>
        </Box>
  
  </Box>
}

          

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>{
          setQrDialog(false);
          }} variant="outlined" color="secondary">
            Close
          </Button>
          
        </DialogActions>
      </Dialog>


{/* get schedule tickets  */}

<Dialog fullScreen open={ticketsDialog} onClose={()=>{
  setTicketsDialog(false);
}} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={()=>{
  setTicketsDialog(false);
}} aria-label="close">
              <Close />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Tickets 
            </Typography>
            <Button autoFocus color="inherit" onClick={()=>{
  setTicketsDialog(false);
}}>
              Close
            </Button>
          </Toolbar>
        </AppBar>


        <Box mt={2}>
{ticketsLoad&&<LinearProgress />}
<MUIDataTable
  title={"Tickets list"}
  data={tickets}
  columns={columns1}
  options={options1}
/>
</Box> 

      </Dialog>



    </div>
  </MuiPickersUtilsProvider>);
}





export default  withLocalize(Schedule);